import React from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
  IonButton,
  IonItem,
  IonBadge,
} from "@ionic/react";
import InputItem from "../../../components/formItems/InputItem";
import TextAreaItem from "../../../components/formItems/TextAreaItem";
import { useDispatch } from "react-redux";
import {
  loadRecord,
  loadPlan,
  loadPersonalFile,
} from "../../patient/patientSlice";
import { getFullName } from "../../../components/util/helpers";
import { Orders } from "./Orders";
const PatientDetails = (props) => {
  const {
    control,
    present,
    loading,
    type,
    hideShowPatientBtn,
    patientId,
    branchId,
    activeHouseVisit,
  } = props;
  const dispatch = useDispatch();
  const intl = useIntl();
  const orders = useSelector((state) => state.visit.activeHouseVisit.orders);
  const fullname =
    activeHouseVisit?.patient__surename && activeHouseVisit?.patient__first_name
      ? getFullName(
        activeHouseVisit.patient__surename,
        activeHouseVisit.patient__first_name,
      )
      : null;

  return (
    <IonCard>
      <IonCardHeader>
        {fullname && <IonCardTitle>{fullname}</IonCardTitle>}
      </IonCardHeader>

      <IonCardContent>
        <InputItem
          name="patient__local_id_number"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.local_id_number",
          })}
          readonly={true}
          loading={loading}
        />

        <InputItem
          name="mobile_number"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.mobile_number",
          })}
          readonly={true}
          loading={loading}
        />
        <InputItem
          name="phone_number"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.phone_number",
          })}
          readonly={true}
          loading={loading}
        />

        <InputItem
          name="patient_address"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.patient_address",
          })}
          readonly={true}
          loading={loading}
        />

        {orders && orders.length > 0 && (
          <Orders
            customerLabel={intl.formatMessage({
              id: "app.mobile.forms.house_visits.customer_label",
            })}
            fromText={intl.formatMessage({
              id: "app.mobile.forms.house_visits.from",
            })}
            orders={orders}
            maxHoursLabel={intl.formatMessage({
              id: "app.mobile.forms.house_visits.hours_label",
            })}
            toText={intl.formatMessage({
              id: "app.mobile.forms.house_visits.to",
            })}
          ></Orders>
        )}

        {activeHouseVisit &&
          activeHouseVisit.patient__house_visit_comments &&
          activeHouseVisit.patient__house_visit_comments !== "" && (
            <TextAreaItem
              name="house_visit_comments"
              control={control}
              label={intl.formatMessage({
                id: "app.mobile.forms.house_visits.house_visit_comments",
              })}
              readonly={true}
              loading={loading}
              rows={4}
            />
          )}

        {activeHouseVisit.patient__emergency__has_emergency_details && (
          <IonItem lines="none">
            <IonBadge color="warning">
              {intl.formatMessage({
                id: "app.mobile.forms.house_visits.emergency_details_exists",
              })}
            </IonBadge>
          </IonItem>
        )}

        {type !== "new" && !hideShowPatientBtn && present && (
          <IonItem lines="none" style={{ paddingTop: "8px" }}>
            <IonButton
              fill="outline"
              size="default"
              onClick={async () => {
                const params = {
                  id: patientId,
                  branchId: branchId,
                  admin: false,
                  patientId: patientId,
                };
                await dispatch(loadRecord(params));
                await dispatch(loadPlan(params));
                await dispatch(loadPersonalFile({ patientId }));
                present();
              }}
            >
              {intl.formatMessage({
                id: "app.mobile.actions.show_patient_card",
              })}
            </IonButton>
          </IonItem>
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default PatientDetails;
